import { Routes } from '@angular/router';
import { EditPageComponent } from './edit-page/edit-page.component';
import { AuthGuard } from '../../../guards/auth.guard';
import { IsCompletedUserDataGuard } from '../../../guards/is-completed-user-data.guard';
import {
  opinionOnIssuingADecisionRoutes
} from './opinion-on-issuing-a-decision/opinion-on-issuing-a-decision.routes';
import { compensationForLossesRoutes } from './compensation-for-losses/compensation-for-losses.routes';
import { placementAdvertisingRoutes } from './placement-advertising/placement-advertising.routes';
import {
  opinionOnTheProjectOfTrafficOrgRoutes
} from './opinion-on-the-project-of-traffic-org/opinion-on-the-project-of-traffic-org.routes';
import {
  approvalOfTrafficOrganizationProjectsRoutes
} from './approval-of-traffic-organization-projects/approval-of-traffic-organization-projects.routes';
import {
  localisationDevicesUnrelatedToRoadRoutes
} from './localisation-devices-unrelated-to-road/localisation-devices-unrelated-to-road.routes';
import {
  locationOfDevicesUnrelatedToRoadRoutes
} from './location-of-devices-unrelated-to-road/location-of-devices-unrelated-to-road.routes';
import { carryingOutWorksRoutes } from './carrying-out-works-application/carrying-out-works.routes';
import {
  locationReconstructionOfExitRoutes
} from './location-reconstruction-of-exit-application/location-reconstruction-of-exit.routes';
import {
  publicInformationDisclosureRoutes
} from './public-information-disclosure/public-information-disclosure.routes';
import {
  notificationGeneralRemarksRoutes
} from './notification-general-remarks-road-marking/notification-general-remarks-road-marking.routes';
import {
  consentReconstructionRenovationOfBuildsRoutes
} from './consent-reconstruction-renovation-of-buildings/consent-reconstruction-renovation-of-buildings.routes';
import { responseToCallRoutes } from './response-to-call/response-to-call.routes';
import { documentsInformationRoutes } from './documents-information/documents-information.routes';
import { generalLetterRoutes } from './general-letter/general-letter.routes';
import {
  occupationOfLanePlacementConstructionObjectsRoutes
} from './occupation-of-lane-placement-construction-objects/occupation-of-lane-placement-construction-objects.routes';
import {
  takeOverLaneReconstructionOfExitRoutes
} from './take-over-lane-reconstruction-of-exit/take-over-lane-reconstruction-of-exit.routes';
import { permitForOversizeVehiclesRoutes } from './permit-for-oversize-vehicles/permit-for-oversize-vehicles.routes';
import { notificationOfEmergencyRoutes } from './notification-of-emergency/notification-of-emergency.routes';

export const applicationEditPageRoutes: Routes = [
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/odpowiedz-na-wezwanie',
    children: responseToCallRoutes,
    data: {
      contentUrl: 'odpowiedz-na-wezwanie'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/uzupelnienie-dokumentow',
    children: documentsInformationRoutes,
    data: {
      contentUrl: 'uzupelnienie-dokumentow'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/pismo-ogolne',
    children: generalLetterRoutes,
    data: {
      contentUrl: 'pismo-ogolne'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/opinia-w-sprawie-wydania-decyzji',
    children: opinionOnIssuingADecisionRoutes,
    data: {
      contentUrl: 'opinia-w-sprawie-wydania-decyzji'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/odszkodowanie-za-straty',
    children: compensationForLossesRoutes,
    data: {
      contentUrl: 'odszkodowanie-za-straty'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/umieszczenie-reklamy',
    children: placementAdvertisingRoutes,
    data: {
      contentUrl: 'umieszczenie-reklamy'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/opinia-do-projektu-organizacji-ruchu-dla-drog-publicznych',
    children: opinionOnTheProjectOfTrafficOrgRoutes,
    data: {
      contentUrl: 'opinia-do-projektu-organizacji-ruchu-dla-drog-publicznych'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/zatwierdzenie-projektow-organizacji-ruchu-dla-drog-wewnetrznych',
    children: approvalOfTrafficOrganizationProjectsRoutes,
    data: {
      contentUrl: 'zatwierdzenie-projektow-organizacji-ruchu-dla-drog-wewnetrznych'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/lokalizacja-urzadzenia-niezwiazanego-z-funkcjonowaniem-drogi',
    children: localisationDevicesUnrelatedToRoadRoutes,
    data: {
      contentUrl: 'lokalizacja-urzadzenia-niezwiazanego-z-funkcjonowaniem-drogi'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/umieszczenie-urzadzenia-niezwiazanego-z-funkcjonowaniem-drogi',
    children: locationOfDevicesUnrelatedToRoadRoutes,
    data: {
      contentUrl: 'umieszczenie-urzadzenia-niezwiazanego-z-funkcjonowaniem-drogi'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/zajecie-pasa-prowadzenie-robot',
    children: carryingOutWorksRoutes,
    data: {
      contentUrl: 'zajecie-pasa-prowadzenie-robot'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/lokalizacja-przebudowa-zjazdu',
    children: locationReconstructionOfExitRoutes,
    data: {
      contentUrl: 'lokalizacja-przebudowa-zjazdu'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/awaryjne-zajecie-pasa-drogowego',
    children: notificationOfEmergencyRoutes,
    data: {
      contentUrl: 'awaryjne-zajecie-pasa-drogowego'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/udostepnienie-informacji-publicznej',
    children: publicInformationDisclosureRoutes,
    data: {
      contentUrl: 'udostepnienie-informacji-publicznej'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/zgloszenie-uwagi-ogolne-oznakowanie-drog',
    children: notificationGeneralRemarksRoutes,
    data: {
      contentUrl: 'zgloszenie-uwagi-ogolne-oznakowanie-drog'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/zgoda-przebudowa-remont-obiektow-budowlanych',
    children: consentReconstructionRenovationOfBuildsRoutes,
    data: {
      contentUrl: 'zgoda-przebudowa-remont-obiektow-budowlanych'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/zajecie-pasa-umieszczenie-obiektow-budowlanych',
    children: occupationOfLanePlacementConstructionObjectsRoutes,
    data: {
      contentUrl: 'zajecie-pasa-umieszczenie-obiektow-budowlanych'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/zajecie-pasa-budowa-przebudowa-zjazdu',
    children: takeOverLaneReconstructionOfExitRoutes,
    data: {
      contentUrl: 'zajecie-pasa-budowa-przebudowa-zjazdu'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: EditPageComponent,
    path: 'wnioski-robocze/zezwolenie-przejazdy-pojazdow-nienormatywnych',
    children: permitForOversizeVehiclesRoutes,
    data: {
      contentUrl: 'zezwolenie-przejazdy-pojazdow-nienormatywnych'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  }
];
